import {
  VALIDATION_ERROR,
  RESET_VALIDATION_ERROR,
  DISMISS_VALIDATION_ERROR,
} from "./../actions/actionTypes";

const initState = {
  err_alerts: [],
};

export const validationReducer = (state = initState, action) => {
  switch (action.type) {
    case VALIDATION_ERROR:
      return {
        ...state,
        err_alerts: [...state.err_alerts, action.err_alerts],
      };
    case RESET_VALIDATION_ERROR:
      return {
        ...state,
        err_alerts: [],
      };
    case DISMISS_VALIDATION_ERROR:
      return {
        ...state,
        err_alerts: action.err_alerts,
      };
    default:
      return state;
  }
};
